import { gql } from "@apollo/client";

export const Edit_WIDGET_DETAILS = gql`
mutation MyMutation($WidgetId: Int!, $Name: String!, $Size: String! ,$WelcomeText: String! ) {
    update_msgbox_Widget(where: {WidgetId: {_eq: $WidgetId}}, _set: {Name: $Name, Size: $Size, WelcomeText: $WelcomeText}){
        affected_rows
      }
  }
`;  